var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',[_c('AutocompleteDepartment',{staticClass:"ml-4",staticStyle:{"width":"90%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"prepend":'dns'},on:{"return-selection":_vm.changeHandler}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494700e1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/SearchDept.vue
// module id = null
// module chunks = 